import React from 'react';
import { ShieldCheckIcon, CheckIcon, MailIcon, RefreshCwIcon, MessageCircleOffIcon, ArrowRightIcon } from 'lucide-react';
const guarantees = [{
  icon: RefreshCwIcon,
  title: 'Rimborso integrale',
  desc: 'Ti restituiamo ogni centesimo, senza trattenute.'
}, {
  icon: MessageCircleOffIcon,
  title: 'Senza domande',
  desc: 'Nessuna giustificazione richiesta. Basta una email.'
}, {
  icon: MailIcon,
  title: 'Procedura semplice',
  desc: 'Una sola mail e in 24h ricevi conferma del rimborso.'
}];
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-240">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-241"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-242">
        <div className="text-center mb-8 sm:mb-12" data-id="element-243">
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-cta-green uppercase tracking-[0.2em] mb-3 bg-cta-green/10 border border-cta-green/20 px-4 py-1.5 rounded-full" data-id="element-244">
            <ShieldCheckIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-245" />
            Garanzia totale
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-tight max-w-3xl mx-auto" data-id="element-246">
            Rischio zero,
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cta-green to-emerald-300" data-id="element-247">
              {' '}
              14 giorni di prova
            </span>
          </h2>
        </div>

        <div className="bg-bg-alt border-2 border-cta-green/30 shadow-[0_0_50px_rgba(16,185,129,0.15)] rounded-2xl sm:rounded-3xl overflow-hidden relative" data-id="element-248">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-cta-green/10 blur-3xl pointer-events-none" data-id="element-249"></div>
          <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-cta-green/5 blur-3xl pointer-events-none" data-id="element-250"></div>

          <div className="grid grid-cols-1 md:grid-cols-[auto,1fr] gap-8 sm:gap-12 p-8 sm:p-12 relative z-10 items-center" data-id="element-251">
            {/* Shield seal */}
            <div className="flex justify-center md:justify-start" data-id="element-252">
              <div className="relative" data-id="element-253">
                <div className="absolute inset-0 rounded-full bg-cta-green/20 blur-2xl" data-id="element-254"></div>
                <div className="relative w-36 h-36 sm:w-44 sm:h-44 rounded-full bg-gradient-to-br from-cta-green/25 to-cta-green/5 border-2 border-cta-green/40 flex flex-col items-center justify-center shadow-[inset_0_0_30px_rgba(16,185,129,0.2)]" data-id="element-255">
                  <ShieldCheckIcon className="w-10 h-10 sm:w-12 sm:h-12 text-cta-green mb-1" strokeWidth={2.2} data-id="element-256" />
                  <span className="text-cta-green font-black text-2xl sm:text-3xl leading-none" data-id="element-257">
                    14
                  </span>
                  <span className="text-cta-green text-[10px] sm:text-xs font-black uppercase tracking-wider mt-0.5" data-id="element-258">
                    Giorni
                  </span>
                </div>
                {/* decorative dots */}
                <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-cta-green animate-pulse-composited" data-id="element-259"></span>
              </div>
            </div>

            <div className="text-center md:text-left" data-id="element-260">
              <h3 className="text-2xl sm:text-3xl font-black text-text-main mb-4 leading-tight" data-id="element-261">
                Recupera il tuo tempo, o ti rimborsiamo.
              </h3>
              <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium mb-6" data-id="element-262">
                Siamo così sicuri di Matematica Pronta che ti diamo{' '}
                <span className="text-cta-green font-black" data-id="element-263">
                  14 giorni interi
                </span>{' '}
                per metterlo alla prova. Se non senti che il tuo lavoro è
                diventato più veloce, facile e organizzato, ti restituiamo ogni
                centesimo.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4" data-id="element-264">
                {guarantees.map((g, i) => {
                const Icon = g.icon;
                return <div key={i} className="bg-bg-main/50 border border-border-light rounded-xl p-4 flex flex-col items-center sm:items-start text-center sm:text-left gap-2" data-id="element-265">
                      <div className="w-9 h-9 rounded-lg bg-cta-green/15 border border-cta-green/30 flex items-center justify-center flex-shrink-0" data-id="element-266">
                        <Icon className="w-5 h-5 text-cta-green" strokeWidth={2.3} data-id="element-267" />
                      </div>
                      <p className="text-text-main font-black text-sm leading-tight" data-id="element-268">
                        {g.title}
                      </p>
                      <p className="text-text-sec text-xs leading-relaxed" data-id="element-269">
                        {g.desc}
                      </p>
                    </div>;
              })}
              </div>
            </div>
          </div>

          {/* Footer band */}
          <div className="bg-cta-green/10 border-t border-cta-green/20 px-6 sm:px-12 py-4 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-3 relative z-10" data-id="element-270">
            <p className="text-text-main text-sm sm:text-base font-bold flex items-center gap-2 text-center sm:text-left" data-id="element-271">
              <CheckIcon className="w-5 h-5 text-cta-green flex-shrink-0" strokeWidth={3} data-id="element-272" />
              Tu provi, noi ci assumiamo il rischio.
            </p>
            <a href="#pricing" className="text-cta-green font-black text-sm sm:text-base flex items-center gap-1.5 hover:gap-3 transition-all whitespace-nowrap" data-id="element-273">
              Acquista in sicurezza
              <ArrowRightIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-274" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}